import React from "react";
import Button from "./button";
import Instagram from "../assets/icons/instagram.svg";
import Linkedin from "../assets/icons/linkedin.svg";
import Twitter from "../assets/icons/twitter.svg";
import Facebook from "../assets/icons/facebook.svg";

export default function Social({ data }) {
  return (
    <section id="social">
      {data.instagram && (
        <Button
          callback={() => {
            window.location.href = `${data.instagram}`;
          }}
          icon={Instagram}
          text="Instagram"
        />
      )}
      {data.linkedinUrl && (
        <Button
          callback={() => {
            window.location.href = `${data.linkedinUrl}`;
          }}
          icon={Linkedin}
          text="Linkedin"
        />
      )}
      {data.twitter && (
        <Button
          callback={() => {
            window.location.href = `${data.twitter}`;
          }}
          icon={Twitter}
          text="Twitter"
        />
      )}
      {data.facebook && (
        <Button
          callback={() => {
            window.location.href = `${data.facebook}`;
          }}
          icon={Facebook}
          text="Facebook"
        />
      )}
    </section>
  );
}

//   {
//     "id": 4,
//     "name": "Dave",
//     "surname": "Schoonbrood",
//     "username": "dschoonbrood",
//     "postCode": null,
//     "country": null,
//     "city": null,
//     "county": null,
//     "street": null,
//     "companyEmail": null,
//     "linkedinUrl": null,
//     "note": null,
//     "email": "dschoonbrood@property.tech",
//     "phone": "+31 6 22551455",
//     "companyPhone": "",
//     "organization": "Property Technology Solutions",
//     "title": "Co-founder",
//     "link": "property.tech",
//     "status": 1
// }
